// Route `api` cho thực thể `task` (J-DT): JSON của `/v1/tasks` (sp.TblPersonalTask, việc của người đăng nhập, không tiền) → `TaskRow` của màn Việc & Duyệt.
// Hub gom qua `module.api`; worker chưa có SQL 012 / chưa đăng nhập thì lỗi → màn giữ dữ liệu mẫu.
// Cột worker CHƯA trả (cổng chặn, nhịp gia hạn tối đa, nút hành động) để mặc định trung tính; hạn chỉ so ngày, không tính giờ làm việc.
import type { ApiRoute } from '@hana/data';
import type { TaskRow } from './tasks';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

const pad = (n: number) => String(n).padStart(2, '0');
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayStart = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** Nhóm theo hạn: trước hôm nay / trong hôm nay → quá hạn (chỉ khi đã qua giờ) hoặc hôm nay; sau → sắp tới. */
export function groupOf(due: Date | null, now: Date): TaskRow['grp'] {
  if (!due) return 'next';
  if (due.getTime() < now.getTime()) return 'over';
  return dayStart(due) === dayStart(now) ? 'today' : 'next';
}

export function taskFromApi(r: Row, now: Date = new Date()): TaskRow | null {
  const id = Number(r.TaskID);
  if (!Number.isFinite(id)) return null;
  const raw = str(r.DeadLine);
  const d = raw ? new Date(raw) : null;
  const due = d && !Number.isNaN(d.getTime()) ? d : null;
  const pending = r.TaskPending === true;
  return {
    id,
    code: str(r.TaskGroup).toUpperCase().slice(0, 4) || 'MEMO',
    title: str(r.SumaryInfo) || str(r.TaskGroup),
    obj: str(r.Ref),
    sub: '',
    grp: groupOf(due, now),
    dueK: '',
    due: due ? `${pad(due.getDate())}/${MON[due.getMonth()]}/${due.getFullYear()} ${pad(due.getHours())}:${pad(due.getMinutes())}` : '',
    seat: str(r.PICTask) || str(r.PIC),
    ext: Number(r.ExtendCount) || 0,
    noExt: false,
    gate: 0,
    gateAct: '',
    deleg: !!str(r.PIC) && !!str(r.PICTask) && str(r.PIC) !== str(r.PICTask),
    wait: pending ? 'Chờ bên ngoài' : '',
  };
}

export const taskApiRoute: ApiRoute<TaskRow> = {
  path: '/api/v1/tasks',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { limit, page: Math.floor((q.offset ?? 0) / limit) + 1, done: q.where?.done === undefined ? undefined : q.where.done ? 1 : 0, job: q.where?.job as string | undefined };
  },
  parse: (json) => {
    const j = (json ?? {}) as { items?: unknown; hasMore?: boolean };
    const rows = Array.isArray(j.items) ? (j.items as Row[]) : [];
    return { items: rows.map((r) => taskFromApi(r)).filter((x): x is TaskRow => x !== null), hasMore: j.hasMore === true };
  },
};
